import { Tree } from 'antd'
import { YhBox } from "@/components/YhBox";
import { fieldSetModel } from "../fieldSetModel";
import type { TreeProps } from 'antd/es/tree';
import '../fieldSet.less'

export const Middle = () => {

  const { franchiseeTreeData, selectedFranchisee, setSelectedFranchisee } = fieldSetModel();

  const onSelect: TreeProps['onSelect'] = (selectedKeys, info) => {
    setSelectedFranchisee(info.selectedNodes[0]);
  };

  return (
    <YhBox width="100%" style={{ height: '100vh', overflow: 'auto' }} title="选择加盟商" >
      {franchiseeTreeData.length > 0 && <Tree
        className="p-5"
        treeData={franchiseeTreeData}
        selectedKeys={[selectedFranchisee?.key ?? ""]}
        onSelect={onSelect}
      />}
    </YhBox>
  )
}